export enum MailMergeSendCopyMode {
    SaveNone = 'SaveNone',
    SaveOne = 'SaveOne',
    SaveAll = 'SaveAll',
}

export interface MailMergeViewState {
    /** Tabular recipient data rows (header keys → cell values) */
    data: Record<string, string>[];
    /** How draft copies are saved when sending - default is SaveAll */
    sendCopyMode?: MailMergeSendCopyMode;
}
